import { StoreProvider } from '@starberry/components';

const DatePickerProvider = StoreProvider(
  {
    focusedMonth: new Date(),
    selectedDate: new Date(),
  },
  (state, action) => {
    switch (action.type) {
      case 'FOCUS_MONTH':
        return { ...state, focusedMonth: action.payload };
      case 'SELECT_DATE':
        return { ...state, selectedDate: action.payload };
      default:
    }
    return state;
  }
);

export default DatePickerProvider;
